import WebAPI from './WebAPI'

const API_ROOT_OPEN_AP = process.env.API_ROOT_OPEN_AP

class UserAPI extends WebAPI {
  constructor () {
    super({baseURL: API_ROOT_OPEN_AP})
  }

  getUsers () {
    return this.__get({extensionURL: '/Users'}).then(resp => resp.data)
  }
}

export default new UserAPI()



// WEBPACK FOOTER //
// ./src/app/api/UserAPI.js